import { render, staticRenderFns } from "./ExaminationFilteringImages.vue?vue&type=template&id=b2778414"
import script from "./ExaminationFilteringImages.vue?vue&type=script&lang=js"
export * from "./ExaminationFilteringImages.vue?vue&type=script&lang=js"
import style0 from "./ExaminationFilteringImages.vue?vue&type=style&index=0&id=b2778414&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports